import React from "react";
import { PageHeader } from "./About";
import { FileText, ScrollText, Mail } from "lucide-react";
import { companyInfo } from "../mock";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-2xl font-bold text-knight-navy mb-3">{title}</h2>
    <div className="text-knight-navy/80 leading-relaxed space-y-3 text-[15px]">{children}</div>
  </div>
);

const Terms = () => (
  <main>
    <PageHeader title="Terms of Service" subtitle="LEGAL" />
    <section className="py-16">
      <div className="max-w-3xl mx-auto px-4">
        <div className="inline-flex items-center gap-2 bg-knight-navy/5 border border-knight-navy/10 rounded-full px-4 py-1.5 mb-6">
          <ScrollText size={14} className="text-knight-gold" />
          <span className="text-xs font-semibold tracking-wide text-knight-navy">Last updated: February 2026</span>
        </div>

        <p className="text-knight-navy/75 mb-10 leading-relaxed">
          These Terms of Service ("Terms") govern your use of Knight Credit Consultants' website and credit-repair, education, and monitoring services. By using our services, you agree to these Terms.
        </p>

        <Section title="1. Services Description">
          <p>We help consumers dispute inaccurate, unverifiable, or outdated items on their credit reports under the Fair Credit Reporting Act (FCRA), Credit Repair Organizations Act (CROA), and applicable state laws. We do not guarantee any specific credit score increase or item removal.</p>
        </Section>

        <Section title="2. Your Right to Cancel (CROA)">
          <p>Under the Credit Repair Organizations Act, you have the <strong>right to cancel this contract within three business days</strong> of signing, without any cost or obligation. You may also cancel at any time after that without penalty.</p>
        </Section>

        <Section title="3. Fees & Billing">
          <p>The First Work Fee is charged 5 days after we complete your credit report audit. Monthly subscription fees are charged on a recurring basis until you cancel. Biweekly billing is available on request. Add-on services are billed once or per the schedule disclosed at purchase.</p>
          <p>We will retry one failed payment per billing cycle and notify you by email or SMS. You may dispute charges with your bank, but disputing valid charges may result in account suspension.</p>
        </Section>

        <Section title="4. Your Responsibilities">
          <p>You agree to (a) provide accurate and complete information; (b) not use our services for unlawful purposes; (c) maintain an active credit-monitoring subscription (e.g., SmartCredit) so we can pull updated reports; (d) cooperate with information requests needed to work disputes.</p>
        </Section>

        <Section title="5. Limitation of Liability">
          <p>To the maximum extent permitted by law, our total liability for any claim arising out of these Terms or your use of our services is limited to the fees you paid in the prior 12 months.</p>
        </Section>

        <Section title="6. No Guarantees">
          <p>By federal law, no credit repair company can guarantee specific results. Outcomes depend on the accuracy and verifiability of your report data and the bureau/furnisher response. We guarantee professional, ethical, transparent dispute work.</p>
        </Section>

        <Section title="7. Governing Law">
          <p>These Terms are governed by the laws of the State of Ohio, without regard to conflict-of-laws principles.</p>
        </Section>

        <Section title="8. Changes to These Terms">
          <p>We may update these Terms from time to time. Continued use of our services after a change constitutes acceptance of the updated Terms.</p>
        </Section>

        <Section title="9. Contact Us">
          <div className="bg-slate-50 border border-slate-200 rounded-2xl p-5">
            <p className="flex items-center gap-2 mb-2"><Mail size={16} className="text-knight-gold" /> <a href={`mailto:${companyInfo.email}`} className="font-semibold text-knight-navy hover:text-knight-gold">{companyInfo.email}</a></p>
            <p className="flex items-center gap-2"><FileText size={16} className="text-knight-gold" /> {companyInfo.address}</p>
          </div>
        </Section>
      </div>
    </section>
  </main>
);

export default Terms;
